import { createIcon } from "@chakra-ui/icons";

export const AllocationIcon = createIcon({
  displayName: "AllocationIcon",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        d="M6.66602 3.33333C6.66602 4.06971 7.26297 4.66667 7.99935 4.66667C8.73573 4.66667 9.33268 4.06971 9.33268 3.33333C9.33268 2.59695 8.73573 2 7.99935 2C7.26297 2 6.66602 2.59695 6.66602 3.33333Z"
        fill="currentColor"
      />
      <path
        d="M10.9993 12.6667C10.9993 13.403 11.5963 14 12.3327 14C13.0691 14 13.666 13.403 13.666 12.6667C13.666 11.9303 13.0691 11.3333 12.3327 11.3333C11.5963 11.3333 10.9993 11.9303 10.9993 12.6667Z"
        fill="currentColor"
      />
      <path
        d="M2.33268 12.6667C2.33268 13.403 2.92964 14 3.66602 14C4.4024 14 4.99935 13.403 4.99935 12.6667C4.99935 11.9303 4.4024 11.3333 3.66602 11.3333C2.92964 11.3333 2.33268 11.9303 2.33268 12.6667Z"
        fill="currentColor"
      />
      <path
        d="M3.66602 11.3333V11.2C3.66602 10.0799 3.66602 9.51984 3.884 9.09202C4.07575 8.71569 4.38171 8.40973 4.75803 8.21799C5.18586 8 5.74591 8 6.86601 8H9.13268C10.2528 8 10.8128 8 11.2407 8.21799C11.617 8.40973 11.9229 8.71569 12.1147 9.09202C12.3327 9.51984 12.3327 10.0799 12.3327 11.2V11.3333M3.66602 11.3333C2.92964 11.3333 2.33268 11.9303 2.33268 12.6667C2.33268 13.403 2.92964 14 3.66602 14C4.4024 14 4.99935 13.403 4.99935 12.6667C4.99935 11.9303 4.4024 11.3333 3.66602 11.3333ZM12.3327 11.3333C11.5963 11.3333 10.9993 11.9303 10.9993 12.6667C10.9993 13.403 11.5963 14 12.3327 14C13.0691 14 13.666 13.403 13.666 12.6667C13.666 11.9303 13.0691 11.3333 12.3327 11.3333ZM7.99935 4.66667L8 8M7.99935 4.66667C7.26297 4.66667 6.66602 4.06971 6.66602 3.33333C6.66602 2.59695 7.26297 2 7.99935 2C8.73573 2 9.33268 2.59695 9.33268 3.33333C9.33268 4.06971 8.73573 4.66667 7.99935 4.66667Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  defaultProps: {
    width: "16px",
    height: "16px",
  },
});
